import { ToolkitPromptFormModal, type ToolkitPromptFormValues } from '@/ui/components/ToolkitPromptFormModal';
import { useSavePromptToToolkit } from '../hooks';

export const CREATE_USER_TOOLKIT_PROMPT_LABEL = 'Create a new prompt';

const EMPTY_VALUES: ToolkitPromptFormValues = { toolName: '', toolDescription: '', prompt: '' };

export interface CreateUserToolkitPromptModalProps {
  visible: boolean;
  onHide: () => void;
}

export const CreateUserToolkitPromptModal = ({ visible, onHide }: CreateUserToolkitPromptModalProps) => {
  const { handleSubmit, isLoading } = useSavePromptToToolkit({ onSuccess: onHide });

  return (
    <ToolkitPromptFormModal
      visible={visible}
      onHide={onHide}
      title={CREATE_USER_TOOLKIT_PROMPT_LABEL}
      initialValues={EMPTY_VALUES}
      onSubmit={handleSubmit}
      isSubmitting={isLoading}
    />
  );
};
